import * as Core from '@skylab-shared/core';
import { CalculationMethod } from '../common/calculation-method';
import { InventoryDocumentKind } from './inventory-document-kind';


export class InventoryKindModel extends Core.ModelBase {
    @Core.Property()
    public adjustment: boolean;

    @Core.Property()
    @Core.ShortString('data-model.document-configuration.validation.custom-transaction-location.length')
    public customTransactionLocation: string;

    @Core.Property()
    public defaultCalculationMethod: CalculationMethod;

    @Core.Property({ nullable: true })
    public defaultMarginSchemeId: number;

    @Core.Property()
    public defaultPaymentMethodId: number;

    @Core.Property({ identifiable: true })
    public name: InventoryDocumentKind;

    @Core.Property()
    public useCustomTransactionLocation: boolean;
}
